import React from "react";

export const Services = (props) => {
  return (
    <div id="price" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Price</h2>
          <p>Choose the perfect treat for your special occasion.</p>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-4 col-sm-6">
                  <div className="pricing-card">
                    {d.icon.startsWith("/") ? (
                      <div
                        style={{ textAlign: "center", marginBottom: "20px" }}
                      >
                        <img
                          src={d.icon}
                          alt={d.name}
                          style={{
                            width: "80px",
                            height: "80px",
                          }}
                        />
                      </div>
                    ) : (
                      <div className="pricing-icon">
                        <i className={d.icon}></i>
                      </div>
                    )}
                    <div className="pricing-content">
                      <h3>{d.name}</h3>
                      <p className="pricing-description">{d.description}</p>

                      {/* Pricing Table for Cakes */}
                      {d.pricingTable && d.name === "Cakes" && (
                        <>
                          <div className="pricing-table">
                            <table className="cake-pricing-table">
                              <thead>
                                <tr>
                                  <th>Size</th>
                                  <th>Inches</th>
                                  <th>Cm</th>
                                  <th>Price</th>
                                </tr>
                              </thead>
                              <tbody>
                                {d.pricingTable.sizes.map((size, idx) => (
                                  <tr key={idx}>
                                    <td>{size.name}</td>
                                    <td>{size.inches}</td>
                                    <td>{size.cm}</td>
                                    <td className="price-cell highlighted-price">
                                      {size.price}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                          <p
                            style={{
                              fontSize: "14px",
                              color: "#666",
                              marginTop: "10px",
                              fontStyle: "italic",
                            }}
                          >
                            * Final price may vary by design complexity
                          </p>
                        </>
                      )}

                      {/* Pricing Table for Cupcakes */}
                      {d.pricingTable && d.name === "Cupcakes" && (
                        <div className="pricing-table">
                          <table className="cupcake-pricing-table">
                            <thead>
                              <tr>
                                <th>Size</th>
                                <th>Without Filling</th>
                                <th>With Filling</th>
                              </tr>
                            </thead>
                            <tbody>
                              {d.pricingTable.sizes.map((size, idx) => (
                                <tr key={idx}>
                                  <td>{size.name}</td>
                                  <td className="price-cell highlighted-price">
                                    {size.withoutFilling}
                                  </td>
                                  <td className="price-cell highlighted-price">
                                    {size.withFilling}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}

                      {d.features && d.features.length > 0 && (
                        <ul className="pricing-features">
                          {d.features.map((feature, idx) => (
                            <li key={idx}>
                              <i className="fa fa-check"></i> {feature}
                            </li>
                          ))}
                        </ul>
                      )}

                      {/* Price for 3D Cakes at the bottom */}
                      {d.name === "3D Cakes" && (
                        <div className="pricing-price-bottom">
                          <button
                            className="btn btn-custom btn-lg"
                            onClick={(e) => {
                              e.preventDefault();
                              const contactSection =
                                document.getElementById("contact");
                              if (contactSection) {
                                contactSection.scrollIntoView({
                                  behavior: "smooth",
                                });
                              }
                            }}
                            style={{
                              background: "transparent",
                              border: "none",
                              padding: "0",
                              cursor: "pointer",
                            }}
                          >
                            <span className="price">{d.price}</span>
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
